import {connect} from "react-redux";
import {getggLabTestList, addToCart} from "../../../../actions/action";
import {getggLabTestListAction} from "../../../../actions";
import ThyroFilter from '../component/ThyroFilter';
import { Toaster, Intent, Position } from '@blueprintjs/core';


const mapStateToProps = state =>{ //alert(1)

    return{
        ggLabTestList:state.homeThyro.ggLabTestList
    }
}

const mapDispatchToProps = dispatch =>{ //alert(2)
    return{
        getggLabTestList : (obj) =>{
            return getggLabTestList(obj)
                .then((res) => {

                    let resource = res.data;

                    if(resource.status === true) {
                        dispatch(getggLabTestListAction(resource.data))
                    }
                })
                .catch((error)=>{
                    if (401 !== error.response.status) {
                        Toaster.create({position: Position.TOP}).show({
                            message: "Something went wrong.",
                            intent: Intent.DANGER
                        });
                    }
                });
        },

        addToCart : (obj) =>{
            return addToCart(obj);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThyroFilter)